package com.example.mystybag.communication.defines

import com.example.mystybag.communication.Communication
import io.ktor.http.URLProtocol

class CommunicationDefines {
    companion object {
        const val PROD_DOMAIN       = "www.mystybag.com"
        const val PROD_REST_HOST    = "api.mystybag.com"

        const val STAGING_DOMAIN    = "staging.mystybag.com"
        const val STAGING_REST_HOST = "staging-api.mystybag.com"

        val PROTOCOL: URLProtocol = URLProtocol.HTTPS

        /**
         * Web origin used for static assets, deep links, etc.
         *
         * Resolves dynamically against the currently initialized
         * [Communication.config.isProduction] so that production builds hit
         * the public site and development/debug builds hit the staging
         * environment (`staging.mystybag.com`).
         */
        val DOMAIN: String
            get() = if (isProduction()) PROD_DOMAIN else STAGING_DOMAIN

        /**
         * REST API host. Mirrors [DOMAIN] — production builds use
         * `api.mystybag.com`, development/debug builds use
         * `staging-api.mystybag.com`.
         */
        val REST_HOST: String
            get() = if (isProduction()) PROD_REST_HOST else STAGING_REST_HOST

        private fun isProduction(): Boolean =
            runCatching { Communication.config.isProduction }.getOrDefault(true)
    }
}
